module.exports = __webpack_public_path__ + "img/jcnr5.7092fbd1.png";